import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgParking = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 21,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 0a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h18Zm0 1h-18v18h18V1ZM11 4c2.61 0 4 1.39 4 4 0 2.53-1.307 3.915-3.766 3.996L11 12H8.5v5h-1V4H11Zm0 1H8.5v6H11c2.057 0 3-.943 3-3 0-1.986-.879-2.934-2.791-2.997L11 5Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgParking;